import React, { useState } from "react"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { UploadIcon, QuestionMarkCircleIcon, LockClosedIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import { toast } from "react-toastify"

import Modal from "../atoms/modal.atom"
import { Header } from "../common/header"
import errorCodes from "../error-codes/error_codes"
import { getCookie } from "../../helper/auth"

export const UploadXl2Json = ({ hubId, onAddTemplate }) => {
	const [isModalVisible, setIsModalVisible] = React.useState(false)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState({})
	const [resJson, setResJson] = useState([])
	const [modalData, setModalData] = useState({})

	const uploadXl = (e) => {
		const file = e.target.files[0]
		console.log(file)
		if (!file) {
			return
		}
		const formData = new FormData()
		formData.append("file", file)
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.post(EndpointConfig.Xl2JSONUpload, formData, {
				headers: { Authorization: `Bearer ${token}` }
			})
			const reqTemplates = (res.data?.data || []).map((template) => {
				// Add validations
				return {
					name: template["Template Name"],
					text: template["Template Text"],
					userId: template["User ID"],
					senderId: template["Sender Id"],
					dtlTemplateId: template["DLT TemplateId"],
					contentType: template["Content Type"],
					status: template["Status"],
					module: "Contact"
				}
			})
			setResJson(reqTemplates)
			toast("Please approve the template table")
		})()
			.catch((err) => {
				console.err(err)
				toast("Failed")
			})
			.finally(() => setLoading(false))
	}

	const saveTemplates = () => {
		if (!resJson.length) {
			toast("Please upload the excel file")
			return
		}

		setError({})
		setLoading(true)
		;(async () => {
			const res = await axiosInstance.post(
				EndpointConfig.VFSMSTemplates,
				{
					templates: resJson
				},
				{ headers: { "hub-id": hubId } }
			)
			console.log("res", res.data)
			setIsModalVisible(true)
			setModalData(res.data)
			toast("Saved Successfully")
			setResJson([])
		})()
			.catch((err) => {
				console.error(err)
				toast("Failed")
			})
			.finally(() => setLoading(false))
	}

	return (
		<>
			<Modal
				children={
					<div className="flex font-sans">
						<form className="flex-auto p-6">
							<div className="flex flex-wrap">
								<h1 className="flex-auto text-lg font-semibold text-slate-900">
									Success
								</h1>
								{JSON.stringify(modalData?.errorCodes) ===
								JSON.stringify({}) ? null : (
									<div class="relative flex flex-col items-center group mr-5 pb-2">
										<svg
											class="w-5 h-5"
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 20 20"
											fill="currentColor"
										>
											<path
												fill-rule="evenodd"
												d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
												clip-rule="evenodd"
											/>
										</svg>
										<div className="absolute bottom-0 flex flex-col items-end hidden mb-6 group-hover:flex">
											<span className="absolute min-w-max h-min z-10 p-2 mt-4 text-xs leading-none text-black whitespace-no-wrap bg-white border-2 shadow-lg">
												<h1 className="flex-auto text-sm font-semibold text-slate-900">
													{"Error Codes"}
												</h1>
												<h1 className="flex-auto text-sm font-semibold text-slate-900">
													{JSON.stringify(modalData) ===
													JSON.stringify({})
														? null
														: modalData?.errorCodes["01"]
														? errorCodes["01"]
														: null}
												</h1>
												<h1 className="flex-auto text-sm font-semibold text-slate-900">
													{JSON.stringify(modalData) ===
													JSON.stringify({})
														? null
														: modalData?.errorCodes["02"]
														? errorCodes["02"]
														: null}
												</h1>
											</span>
										</div>
									</div>
								)}

								<div className="w-full flex-none text-sm font-normal text-slate-700 mt-2 items-center justify-center">
									<h1 className="flex-auto text-sm font-semibold text-slate-900">
										{"Total Uploaded Record : " + modalData?.uploadedCount}
									</h1>
									<h1 className="flex-auto text-sm font-semibold text-slate-900">
										{"Total Skip Record : " + modalData?.skipCount}
									</h1>
									{JSON.stringify(modalData?.errorCodes) ===
									JSON.stringify({}) ? null : (
										<h1 className="flex-auto text-sm font-semibold text-slate-900">
											{JSON.stringify(modalData) === JSON.stringify({})
												? null
												: "Error Codes : { " +
												  Object.keys(modalData?.errorCodes).join(", ") +
												  " }"}
										</h1>
									)}
								</div>
							</div>
							<div className="flex space-x-4 mb-1 my-5 text-sm font-medium">
								<div className="flex-auto flex space-x-4 items-center justify-center">
									<button
										className="h-10 px-6 font-semibold rounded-md bg-blue-700 text-white"
										type="submit"
										onClick={() => {
											setIsModalVisible(false)
											onAddTemplate?.()
										}}
									>
										OK
									</button>
								</div>
							</div>
						</form>
					</div>
				}
				toggle={() => setIsModalVisible(false)}
				open={isModalVisible}
			/>
			<div className="flex flex-col">
				<Header IconName={UploadIcon} subText={"Upload"} mainText={"Upload Templates"} />
				<div className="flex flex-col bg-white p-4">
					<div className="flex flex-col flex-1 mr-2">
						<Input
							name="name"
							type="file"
							onChange={uploadXl}
							accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
						/>
						{loading ? "loading" : null}
						{/* {loading ? <Button className="text-xs p-1 bg-red-100 text-black pointer-events-none"  >Loading</Button> : */}
						{/* <Button className="text-xs p-1 mt-2" onClick={addTemplate} >Save Template</Button>} */}
					</div>
					{resJson.length > 0 && (
						<div className="flex flex-col overflow-x-auto pb-4">
							<div className="py-2 inline-block">
								<table className="common">
									<thead className="">
										<tr className="">
											<th className="">#</th>
											<th className="">Template Name</th>
											<th className="">Template Text</th>
											<th className="">Template User Id</th>
											<th className="">Template Sender Id</th>
											<th className="">Template DTL Id</th>
											<th className="">Template Content Type</th>
											<th className="">Template Status</th>
										</tr>
									</thead>
									<tbody>
										{resJson.map((template, i) => (
											<tr key={i}>
												<td className=""> {i + 1} </td>
												<td className="">{template.name}</td>
												<td className="">{template.text}</td>
												<td className="">{template.userId}</td>
												<td className="">{template.senderId}</td>
												<td className="">{template.dtlTemplateId}</td>
												<td className="">{template.contentType}</td>
												<td className="">{template.status}</td>
												{/* <td className="">
                                                <div className="flex flex-row gap-2">
                                                     <ChatIcon className="text-red-500 w-4 h-4 cursor-pointer" onClick={() => { }} /> 
                                                     <TrashIcon className="text-red-500 w-4 h-4 cursor-pointer" onClick={() => deleteTemplate({ templateId: template._id })} /> 
                                                </div>
                                            </td> */}
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					)}
					{resJson.length > 0 && (
						<>
							<label className="text-xs text-gray-500">
								Please make sure you have 🔒password added for the account:User id,
								that you have upload
							</label>
							<div className="flex flex-row gap-6">
								<div className="flex-[3]">&nbsp;</div>
								<div className="flex-1">
									&nbsp;
									<Button className="w-full" onClick={saveTemplates}>
										Save templates
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</>
	)
}
